import React from 'react'
import Helmet from 'react-helmet'
import { graphql } from 'gatsby'
import get from 'lodash/get'
import {
  Breadcrumbs,
  Hero,
  Link,
  Tile
} from '@storaensods/seeds-react'
import { documentToReactComponents } from "@contentful/rich-text-react-renderer"
import Layout from '../components/layout'

class CaseStudyTemplate extends React.Component {
  render() {
    const study = get(this.props, 'data.contentfulCaseStudy')
    const bgImage = study.image ? "backgroundImage: url("+study.image.resolutions.src+")" : "";

    return (
      <Layout location={this.props.location}>
        <Helmet title={`${study.title} | Case Studies | Stora Enso Design System`} >
      
        <script async src={`https://www.googletagmanager.com/gtag/js?id=UA-157026851-1`} />
        <script>
        {`
           window.dataLayer = window.dataLayer || [];
           function gtag(){dataLayer.push(arguments);}
           gtag('js', new Date());
           gtag('config', 'UA-157026851-1');
        `}
        </script>  
        
        </Helmet>
        <article>
        <div className="se-hero se-hero--md" style={{bgImage}}>
          <div className="se-hero-content-container container">
          <div className="se-hero-content">
            <div className="se-tile se-tile--yellow">
               <h1>{study.title}</h1>
              <div
                dangerouslySetInnerHTML={{
                  __html: study.shortDescription.childMarkdownRemark.html,
                }}
              />
            </div>
          </div>
          </div>
        </div>

        <div className="container">
          <div style={{ marginTop: '-2rem' }}>
            <Breadcrumbs>
              <Link href="/toolkit">
                SEEDS Home
              </Link>
              <Link href="/toolkit">
                Playbook
              </Link>
              <Link href="/toolkit?tab=casestudies">
                Case Studies
              </Link>
              <Link>
                {study.title}
              </Link>
            </Breadcrumbs>
          </div>
          <div>
            {documentToReactComponents(study.content.json)}
          </div>
          </div>
        </article>
      </Layout>
    )
  }
}

export default CaseStudyTemplate

export const pageQuery = graphql`
  query CaseStudyBySlug($slug: String!) {
    contentfulCaseStudy(slug: { eq: $slug }) {
      title
      shortDescription {
        childMarkdownRemark {
          html
        }
      }
      content {
        json
      }
      image {
        resolutions(width: 1280) {
          src
        }
      }
    }
  }
`
